import React, { FC, useContext, useLayoutEffect } from "react"
import { createContext, useState } from "react"

export const makeContext = <T,>(init: () => T): [ FC<{ children: React.ReactNode }>, () => T ] => {

  const StoreContext = createContext({} as T)

  const Provider: FC<{ children: React.ReactNode }> = ({ children }) => {

    const [ store ] = useState(init)
    useLayoutEffect(() => {
      if ("init" in store) {
        const dispose = (store as any).init()
        if ("dispose" in store) {
          return () => (store as any).dispose()
        }
        return dispose
      }  
    }, [ store ])
    
    return (
      <StoreContext.Provider value={store}>
        { children }
      </StoreContext.Provider>
    )
  }

  const useStore = () => {
    return useContext(StoreContext)
  }
  
  return [ Provider, useStore ]

}